import { attach } from 'effector';

import { api } from '@shared/api/api';

const confirmEmailFx = attach({
  effect: api.auth.confirmEmail
});

export { confirmEmailFx };
